export default "__VITE_ASSET__DNdZl1P8__"